import { render, staticRenderFns } from "./AuthenticatedPage.vue?vue&type=template&id=7f6a5874&scoped=true"
import script from "./AuthenticatedPage.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedPage.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticatedPage.vue?vue&type=style&index=0&id=7f6a5874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a5874",
  null
  
)

export default component.exports